import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export const isSameDate = (date1, date2) => {
    if (date1 && date2 && date1 instanceof Date && date2 instanceof Date) {
      return date1.getTime() === date2.getTime();
    }
    return false;
  };


/**
 * Normalizes a date input (string or Date object) to a UTC Date object
 * representing the start of that day (00:00:00.000Z), without shifting the
 * *calendar day* due to local timezone offsets.
 *
 * It handles:
 * - 'YYYY-MM-DD' strings (parsed as that day's UTC midnight)
 * - 'YYYY-MM-DDTHH:MM:SS' strings (parsed correctly and normalized to UTC midnight)
 * - Date objects (converted to 'YYYY-MM-DD' *locally* and then treated as UTC)
 *
 * @param input The date input.
 * @returns The normalized Date object at 00:00:00.000Z, or null if invalid.
 */
export function normalizeDateToUTC(
  input: string | Date | null | undefined
): Date | null {

    if (!input) return null;

    let dateDayjs;

    if (input instanceof Date && !isNaN(input.getTime())) {
        // Convert the Date object to a 'YYYY-MM-DD' string based on its

        const localDateString = dayjs(input).format('YYYY-MM-DD');

        // Parse this 'YYYY-MM-DD' string as UTC.
        dateDayjs = dayjs.utc(localDateString);
    } else {
        // For strings (including 'YYYY-MM-DD' and ISO formats) using dayjs.utc() to parse.
        dateDayjs = dayjs.utc(input);
    }

    if (!dateDayjs.isValid()) return null;

    // Normalize to the start of the day in UTC. Since dayjs.utc() was used,
    // this ensures it's 00:00:00.000Z.
    return dateDayjs.startOf('day').toDate();
}